

import React, {useState} from 'react';
import NavBar from '../../Components/NavBar/NavBar';
// import "../../Components/HeroSection/HeroSection.css"
import "./Landing.css"
import HeroSection from '../../Components/HeroSection/HeroSection';
import CourseOverview from '../../Components/CourseOverview/CourseOverview';
import CMSNews from '../../Components/CMSNews/CMSNews';
import FeaturedCourses from '../../Components/FeaturedCourses/FeaturedCourses';
import OurStrength from '../../Components/OurStrength/OurStrength';
import Faqs from '../../Components/FAQs/FAQs';
import Footer from '../../Components/Footer/Footer';



function Landing() { 
 

  return <>
        <div className='HeroSectionWholezz'>
            
              <HeroSection/>              
       
              {/* <CourseOverview/> */}
              <CMSNews/>
              <FeaturedCourses/>
              <OurStrength/>
              <Faqs/>
              <Footer/>

        </div>
       
    
  </>
  
  ;
}

export default Landing;